<div class="mct-flex mct-col mct-fill">
  <h1>{{ dataQueryDto?.Id > 0 ? dataQueryDto.Name : ('reports.query-tool.create-query' | translate | titlecase) }}</h1>
  <wlx-tabs>
    <wlx-tab #selectFieldsTab [hidden]="dataQueryDto.IsRawSql" [title]="'reports.query-tool.select-fields.title' | translate | titlecase">
      <div>
        <wl-query-tool-select-fields
          (onViewChanged)="viewChanged($event)"
          (onFieldChanged)="buildSql()"
          [queryDefinition]="queryDefinition"
          [rawColumns]="availableFields"
        ></wl-query-tool-select-fields>
        <div class="mt-27 mct-flex mct-row mct-justify-end mct-items-center mct-gap-27"   >
          <button pButton type="button" (click)="selectTab(setFiltersTab)" class="atlas-btn atlas-btn-secondary">
            {{ 'reports.query-tool.set-filters.title' | translate | titlecase }}
            <span class="pi pi-arrow-right ml-10"></span>
          </button>
        </div>
      </div>
    </wlx-tab>
    <wlx-tab #setFiltersTab [hidden]="dataQueryDto.IsRawSql" [title]="'reports.query-tool.set-filters.title' | translate | titlecase">
      <div>
        <wl-query-tool-set-filters [queryDefinition]="queryDefinition" [availableFields]="availableFields" (onFilterChanged)="buildSql()">
        </wl-query-tool-set-filters>
        <div class="mt-27 mct-flex mct-row mct-justify-end mct-items-center mct-gap-27"   >
          <button pButton type="button" (click)="selectTab(selectFieldsTab)" class="atlas-btn atlas-btn-secondary">
            <span class="pi pi-arrow-left mr-10"></span> {{ 'reports.query-tool.select-fields.title' | translate | titlecase }}
          </button>
          <button pButton type="button" (click)="selectTab(setSortOrderTab)" class="atlas-btn atlas-btn-secondary">
            {{ 'reports.query-tool.set-sort-order.title' | translate | titlecase }}
            <span class="pi pi-arrow-right ml-10"></span>
          </button>
        </div>
      </div>
    </wlx-tab>
    <wlx-tab #setSortOrderTab [hidden]="dataQueryDto.IsRawSql" [title]="'reports.query-tool.set-sort-order.title' | translate | titlecase">
      <div>
        <wl-query-tool-set-sort-order
          [availableFields]="availableFields"
          [queryDefinition]="queryDefinition"
          (onSortOrderChange)="buildSql()"
        ></wl-query-tool-set-sort-order>
        <div class="mt-27 mct-flex mct-row mct-justify-end mct-items-center mct-gap-27"   >
          <button pButton type="button" (click)="selectTab(setFiltersTab)" class="atlas-btn atlas-btn-secondary">
            <span class="pi pi-arrow-left mr-10"></span> {{ 'reports.query-tool.set-filters.title' | translate | titlecase }}
          </button>
          <button pButton type="button" (click)="selectViewResultsTab(viewResultsTab)" class="atlas-btn atlas-btn-primary" button>
            {{ 'reports.query-tool.run-this-query' | translate | uppercase }}
          </button>
        </div>
      </div>
    </wlx-tab>
    <wlx-tab [hidden]="dataQueryDto.IsRawSql" isTabWellContent="true">
      <ng-template>
        <hr />
      </ng-template>
    </wlx-tab>
    <wlx-tab #sqlTab [title]="'reports.query-tool.view-sql.title' | translate">
      <div><wl-query-tool-view-sql [dataQueryDto]="dataQueryDto"></wl-query-tool-view-sql></div>
    </wlx-tab>
    <wlx-tab isTabWellContent="true">
      <ng-template>
        <hr />
      </ng-template>
    </wlx-tab>
    <wlx-tab isTabWellContent="true">
      <ng-template>
        <button pButton type="button" (click)="selectViewResultsTab(viewResultsTab)" class="atlas-btn atlas-btn-primary" button>
          {{ 'reports.query-tool.run-this-query' | translate | uppercase }}
        </button>
      </ng-template>
    </wlx-tab>
    <wlx-tab [hidden]="true" #viewResultsTab>
      <div>
        <wl-query-tool-view-results
          [queryDefinition]="queryDefinition"
          [dataQuery]="dataQueryDto"
          [availableFields]="availableFields"
        ></wl-query-tool-view-results>
      </div>
    </wlx-tab>
  </wlx-tabs>
</div>
